import { c as h } from "./@contentful-cca97bae.js";
import { l as N } from "./domelementtype-4b6931b4.js";
var H = {}, a = {}, m = h && h.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, s) {
      o.__proto__ = s;
    } || function(o, s) {
      for (var c in s)
        Object.prototype.hasOwnProperty.call(s, c) && (o[c] = s[c]);
    }, t(e, n);
  };
  return function(e, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    t(e, n);
    function o() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
  };
}(), y = h && h.__assign || function() {
  return y = Object.assign || function(t) {
    for (var e, n = 1, o = arguments.length; n < o; n++) {
      e = arguments[n];
      for (var s in e)
        Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
    }
    return t;
  }, y.apply(this, arguments);
};
Object.defineProperty(a, "__esModule", { value: !0 });
a.cloneNode = a.hasChildren = a.isDocument = a.isDirective = a.isComment = a.isText = a.isCDATA = a.isTag = a.Element = a.Document = a.CDATA = a.NodeWithChildren = a.ProcessingInstruction = a.Comment = a.Text = a.DataNode = a.Node = void 0;
var f = N, x = (
  /** @class */
  function() {
    function t() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(t.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(e) {
        this.parent = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(e) {
        this.prev = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(e) {
        this.next = e;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.cloneNode = function(e) {
      return e === void 0 && (e = !1), T(this, e);
    }, t;
  }()
);
a.Node = x;
var v = (
  /** @class */
  function(t) {
    m(e, t);
    function e(n) {
      var o = t.call(this) || this;
      return o.data = n, o;
    }
    return Object.defineProperty(e.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(n) {
        this.data = n;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(x)
);
a.DataNode = v;
var C = (
  /** @class */
  function(t) {
    m(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.type = f.ElementType.Text, n;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(v)
);
a.Text = C;
var O = (
  /** @class */
  function(t) {
    m(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.type = f.ElementType.Comment, n;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(v)
);
a.Comment = O;
var D = (
  /** @class */
  function(t) {
    m(e, t);
    function e(n, o) {
      var s = t.call(this, o) || this;
      return s.name = n, s.type = f.ElementType.Directive, s;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(v)
);
a.ProcessingInstruction = D;
var b = (
  /** @class */
  function(t) {
    m(e, t);
    function e(n) {
      var o = t.call(this) || this;
      return o.children = n, o;
    }
    return Object.defineProperty(e.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var n;
        return (n = this.children[0]) !== null && n !== void 0 ? n : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(n) {
        this.children = n;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(x)
);
a.NodeWithChildren = b;
var P = (
  /** @class */
  function(t) {
    m(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.type = f.ElementType.CDATA, n;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(b)
);
a.CDATA = P;
var w = (
  /** @class */
  function(t) {
    m(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.type = f.ElementType.Root, n;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(b)
);
a.Document = w;
var j = (
  /** @class */
  function(t) {
    m(e, t);
    function e(n, o, s, c) {
      s === void 0 && (s = []), c === void 0 && (c = n === "script" ? f.ElementType.Script : n === "style" ? f.ElementType.Style : f.ElementType.Tag);
      var p = t.call(this, s) || this;
      return p.name = n, p.attribs = o, p.type = c, p;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(n) {
        this.name = n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var n = this;
        return Object.keys(this.attribs).map(function(o) {
          var s, c;
          return {
            name: o,
            value: n.attribs[o],
            namespace: (s = n["x-attribsNamespace"]) === null || s === void 0 ? void 0 : s[o],
            prefix: (c = n["x-attribsPrefix"]) === null || c === void 0 ? void 0 : c[o]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(b)
);
a.Element = j;
function E(t) {
  return (0, f.isTag)(t);
}
a.isTag = E;
function I(t) {
  return t.type === f.ElementType.CDATA;
}
a.isCDATA = I;
function _(t) {
  return t.type === f.ElementType.Text;
}
a.isText = _;
function A(t) {
  return t.type === f.ElementType.Comment;
}
a.isComment = A;
function S(t) {
  return t.type === f.ElementType.Directive;
}
a.isDirective = S;
function M(t) {
  return t.type === f.ElementType.Root;
}
a.isDocument = M;
function W(t) {
  return Object.prototype.hasOwnProperty.call(t, "children");
}
a.hasChildren = W;
function T(t, e) {
  e === void 0 && (e = !1);
  var n;
  if (_(t))
    n = new C(t.data);
  else if (A(t))
    n = new O(t.data);
  else if (E(t)) {
    var o = e ? g(t.children) : [], s = new j(t.name, y({}, t.attribs), o);
    o.forEach(function(r) {
      return r.parent = s;
    }), t.namespace != null && (s.namespace = t.namespace), t["x-attribsNamespace"] && (s["x-attribsNamespace"] = y({}, t["x-attribsNamespace"])), t["x-attribsPrefix"] && (s["x-attribsPrefix"] = y({}, t["x-attribsPrefix"])), n = s;
  } else if (I(t)) {
    var o = e ? g(t.children) : [], c = new P(o);
    o.forEach(function(i) {
      return i.parent = c;
    }), n = c;
  } else if (M(t)) {
    var o = e ? g(t.children) : [], p = new w(o);
    o.forEach(function(i) {
      return i.parent = p;
    }), t["x-mode"] && (p["x-mode"] = t["x-mode"]), n = p;
  } else if (S(t)) {
    var l = new D(t.name, t.data);
    t["x-name"] != null && (l["x-name"] = t["x-name"], l["x-publicId"] = t["x-publicId"], l["x-systemId"] = t["x-systemId"]), n = l;
  } else
    throw new Error("Not implemented yet: ".concat(t.type));
  return n.startIndex = t.startIndex, n.endIndex = t.endIndex, t.sourceCodeLocation != null && (n.sourceCodeLocation = t.sourceCodeLocation), n;
}
a.cloneNode = T;
function g(t) {
  for (var e = t.map(function(o) {
    return T(o, !0);
  }), n = 1; n < e.length; n++)
    e[n].prev = e[n - 1], e[n - 1].next = e[n];
  return e;
}
(function(t) {
  var e = h && h.__createBinding || (Object.create ? function(l, r, i, u) {
    u === void 0 && (u = i);
    var d = Object.getOwnPropertyDescriptor(r, i);
    (!d || ("get" in d ? !r.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return r[i];
    } }), Object.defineProperty(l, u, d);
  } : function(l, r, i, u) {
    u === void 0 && (u = i), l[u] = r[i];
  }), n = h && h.__exportStar || function(l, r) {
    for (var i in l)
      i !== "default" && !Object.prototype.hasOwnProperty.call(r, i) && e(r, l, i);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.DomHandler = void 0;
  var o = N, s = a;
  n(a, t);
  var c = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, p = (
    /** @class */
    function() {
      function l(r, i, u) {
        this.dom = [], this.root = new s.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof i == "function" && (u = i, i = c), typeof r == "object" && (i = r, r = void 0), this.callback = r ?? null, this.options = i ?? c, this.elementCB = u ?? null;
      }
      return l.prototype.onparserinit = function(r) {
        this.parser = r;
      }, l.prototype.onreset = function() {
        this.dom = [], this.root = new s.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, l.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, l.prototype.onerror = function(r) {
        this.handleCallback(r);
      }, l.prototype.onclosetag = function() {
        this.lastNode = null;
        var r = this.tagStack.pop();
        this.options.withEndIndices && (r.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(r);
      }, l.prototype.onopentag = function(r, i) {
        var u = this.options.xmlMode ? o.ElementType.Tag : void 0, d = new s.Element(r, i, void 0, u);
        this.addNode(d), this.tagStack.push(d);
      }, l.prototype.ontext = function(r) {
        var i = this.lastNode;
        if (i && i.type === o.ElementType.Text)
          i.data += r, this.options.withEndIndices && (i.endIndex = this.parser.endIndex);
        else {
          var u = new s.Text(r);
          this.addNode(u), this.lastNode = u;
        }
      }, l.prototype.oncomment = function(r) {
        if (this.lastNode && this.lastNode.type === o.ElementType.Comment) {
          this.lastNode.data += r;
          return;
        }
        var i = new s.Comment(r);
        this.addNode(i), this.lastNode = i;
      }, l.prototype.oncommentend = function() {
        this.lastNode = null;
      }, l.prototype.oncdatastart = function() {
        var r = new s.Text(""), i = new s.CDATA([r]);
        this.addNode(i), r.parent = i, this.lastNode = r;
      }, l.prototype.oncdataend = function() {
        this.lastNode = null;
      }, l.prototype.onprocessinginstruction = function(r, i) {
        var u = new s.ProcessingInstruction(r, i);
        this.addNode(u);
      }, l.prototype.handleCallback = function(r) {
        if (typeof this.callback == "function")
          this.callback(r, this.dom);
        else if (r)
          throw r;
      }, l.prototype.addNode = function(r) {
        var i = this.tagStack[this.tagStack.length - 1], u = i.children[i.children.length - 1];
        this.options.withStartIndices && (r.startIndex = this.parser.startIndex), this.options.withEndIndices && (r.endIndex = this.parser.endIndex), i.children.push(r), u && (r.prev = u, u.next = r), r.parent = i, this.lastNode = null;
      }, l;
    }()
  );
  t.DomHandler = p, t.default = p;
})(H);
export {
  H as l
};
